import { render, staticRenderFns } from "./FacialRecognitionError.vue?vue&type=template&id=3e570fe8&scoped=true&"
import script from "./FacialRecognitionError.vue?vue&type=script&lang=js&"
export * from "./FacialRecognitionError.vue?vue&type=script&lang=js&"
import style0 from "./FacialRecognitionError.vue?vue&type=style&index=0&id=3e570fe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e570fe8",
  null
  
)

export default component.exports